import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import COLORS from '../../../theme/colors';
import Tabs from '../../generic/Tabs';

import styles from './LicenseDrawer.module.less';

type LicenseContentSkeletonProps = {
  isDependencyScope: boolean;
};

const LicenseContentSkeleton: VoidFunctionComponent<LicenseContentSkeletonProps> = ({ isDependencyScope }) => {
  const tabList = isDependencyScope
    ? ['Summary', 'License Text', 'File Matches', 'Copyrights', 'Obligations']
    : ['Summary', 'License Text', 'Obligations'];

  return (
    <div className={styles.licenseContent}>
      <div className={styles.title}>
        <ContentLoader
          width="100%"
          height={isDependencyScope ? '60px' : '32px'}
          backgroundColor={COLORS.fossaGray10}
          foregroundColor={COLORS.fossaGray20}
        >
          {/* Title */}
          <rect x="0" y="0" rx="3" ry="3" width="200" height="32" />
          {/* Subtitle (if dependency scope) */}
          {isDependencyScope && <rect x="0" y="40" rx="3" ry="3" width="300" height="20" />}
        </ContentLoader>
      </div>

      <div className={styles.licenseContentContainer}>
        <Tabs>
          {tabList.map((tab) => (
            <Tabs.Tab
              key={tab}
              label={tab}
              isActive={tab === 'Summary'}
              onSelect={() => {}}
            />
          ))}
        </Tabs>
        <div className={styles.tabContent}>
          <ContentLoader
            width="100%"
            height="600px"
            backgroundColor={COLORS.fossaGray10}
            foregroundColor={COLORS.fossaGray20}
            >
            {/* Summary text paragraphs */}
            <rect x="0" y="0" rx="3" ry="3" width="100%" height="16" />
            <rect x="0" y="24" rx="3" ry="3" width="75%" height="16" />

            {/* Info box */}
            <rect x="0" y="56" rx="3" ry="3" width="100%" height="40" />

            {/* You Can section title */}
            <rect x="0" y="120" rx="3" ry="3" width="150" height="24" />

            {/* You Can term items */}
            <rect x="0" y="160" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="178" rx="3" ry="3" width="90%" height="12" />

            <rect x="0" y="210" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="228" rx="3" ry="3" width="85%" height="12" />

            <rect x="0" y="260" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="278" rx="3" ry="3" width="88%" height="12" />

            <rect x="0" y="310" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="328" rx="3" ry="3" width="92%" height="12" />

            {/* You Cannot section title */}
            <rect x="0" y="370" rx="3" ry="3" width="150" height="24" />

            {/* You Cannot term items */}
            <rect x="0" y="410" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="428" rx="3" ry="3" width="87%" height="12" />

            <rect x="0" y="460" rx="3" ry="3" width="100%" height="14" />
            <rect x="0" y="478" rx="3" ry="3" width="83%" height="12" />
          </ContentLoader>
        </div>
      </div>
    </div>
  );
};

export default LicenseContentSkeleton;
